import { h } from '@stencil/core';
import cn from 'classnames';
import { EQdsButtonImportance, EQdsButtonSize } from '@pes-ui/utils';
export class AwardsCarouselCardContent {
  constructor() {
    this.award = undefined;
    this.numberOfAwards = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    const { url, name, description, logo } = this.award;
    const isUrlAvailable = !!url;
    return (h("div", { class: "awards-container-padding" }, h("se-block", { option: "card", class: cn('product-awards-block', { 'url-available': isUrlAvailable }) }, h("div", { class: "awards-item_logo" }, h("pes-lazy-img", { src: logo, alt: name })), h("h4", { class: cn('awards-item_name', { 'url-available': isUrlAvailable }) }, name, isUrlAvailable && (h("qds-standalone-link", { size: EQdsButtonSize.STANDARD, importance: EQdsButtonImportance.SUBDUED, href: url, iconName: "arrow-top-right-on-square", target: "_blank" }))), h("p", { class: "awards-item_description" }, description))));
  }
  static get is() { return "pes-awards-carousel-card-content"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["awards-carousel-card-content.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["awards-carousel-card-content.css"]
    };
  }
  static get properties() {
    return {
      "award": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductAward",
          "resolved": "{ name: string; url?: string; description: string; logo: string; }",
          "references": {
            "TProductAward": {
              "location": "import",
              "path": "../../specifications/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "numberOfAwards": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "number-of-awards",
        "reflect": false
      }
    };
  }
  static get elementRef() { return "el"; }
}
